<!--
Author: tianyi
Date: 2019-11-7
Desc: 分红查询
 -->
<template>
    <div :class="'view-dividend view ' + className">
        <comp-title :title="title">
        </comp-title>
        <div class="trade-record">
            <el-row class="fund-filter">
                <el-col :span="24" class="btn-fund">
                    <el-col :span="6">
                        基金代码：
                        <div style="display: inline-block;">
                            <el-input
                                v-model="fundcode"
                                placeholder="请输入基金代码"
                                class="input-search"
                                size="small"
                            />
                        </div>
                    </el-col>
                    <el-col :span="12" :offset="1">
                        红利发放日：
                        <div class="custom-time">
                            <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                            <el-button size="small" type="yellow" v-on:click.prevent="searchFund">
                                查询
                            </el-button>
                        </div>
                    </el-col>
                </el-col>
                <!-- <el-col :span="24" class="btn-search">
                    查询条件：
                    <span v-for="tag in dynamicTags" :key="tag" style="display:inline-block;">
                        <el-tag v-if="tag" closable :disable-transitions="false" v-on:close="handleClose(tag)">{{ tag }}
                        </el-tag>
                    </span>
                    <el-input
                        v-model="searchText"
                        placeholder="请输入基金名称或基金代码"
                        class="input-search"
                        size="small"
                    />
                    <el-button
                        class="btn-search-icon"
                        icon="el-icon-search"
                        type="primary"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-col> -->
            </el-row>
            <el-table
                :data="data"
                style="width: 100%"
                class="tab-list-tit"
            >
                <el-table-column
                    prop=""
                    label="红利发放日"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ !$util.isEmpty(scope.row.dividedate) ? $util.fmtDate(scope.row.dividedate) : $util.fmtDate(scope.row.cfmdate) }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop=""
                    label="基金名称"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.fundname + "(" + scope.row.fundcode + ")" }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="registrationdate"
                    label="权益登记日"
                    align="center"
                    :formatter="formatterDate"
                />
                <!-- <el-table-column
                    prop="appdate"
                    label="除息日"
                    align="center"
                    :formatter="formatterDate"
                /> -->
                <el-table-column
                    prop=""
                    label="分红方式"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ !$util.isEmpty(scope.row.dividename) ? scope.row.dividename : $cache.getDict("110001", scope.row.defdividendmethod) }}
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                    <!--prop="totalshare"-->
                    <!--label="持有份额"-->
                    <!--align="center"-->
                <!--/>-->
                <el-table-column
                    prop="confirmedamount"
                    label="现金红利"
                    align="center"
                />
                <el-table-column
                    prop="confirmedvol"
                    label="红利再投份额"
                    align="center"
                />
            </el-table>
            <el-row v-if="Number(allPage) !== 0" class="page-box">
                <el-pagination
                    background
                    :page-sizes="pageSizes"
                    :page-size="Number(pagecount)"
                    :current-page.sync="curPage"
                    :layout="pageLayout"
                    :total="Number(allPage)"
                    v-on:current-change="pageRefresh"
                    v-on:size-change="sizeReset"
                >
                    <el-button type="primary" plain v-on:click="showAll">{{ !isShowAll ? "显示全部" : "分页展示" }}</el-button>
                </el-pagination>
            </el-row>
        </div>
    </div>
</template>
<script>
import format from "date-fns/format";

import mixin from "@/assets/js/mixin";
import datePicker from "@/components/common/datePicker";
export default {
    name: "TradeRecord",
    components: {
        datePicker
    },
    mixins: [mixin],
    data () {
        return {
            curPage: 1,
            fundcode: "",
            cfmdate: "",
            data: [],
            dynamicTags: [],
            endDate: "",
            beginDate: "",
            nowDate: "", // 当前时间
            pagecount: "",
            pageoffset: "0",
            allPage: "0",
            queryFind: null,
            fundFrom: "1",
            query: null,
            index: 0,
            tradeTimeArr: [// 时间周期
                { val: "1", text: "近7天" },
                { val: "2", text: "近一个月" },
                { val: "3", text: "近三个月" },
                { val: "4", text: "近半年" },
                { val: "5", text: "近一年" },
                { val: "6", text: "自定义" }
            ],
            fundDetail: {},
            isPwdCheck: false,
            dateSet: { type: "2", min: "1990-01-01", size: "mini" },
            isShowAll: false,
            pageSizes: [20, 50, 100],
            pageLayout: "total, slot, sizes, prev, pager, next"
        };
    },
    watch: {
    },
    created () {
        this.isPwdCheck = this.$cache.getPwdCheck("C1");
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.pagecount = "20";//this.$util.getConfig().const.PAGE_SIZE;
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.getInfo();
    },
    methods: {
        formatterDate (row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatStatus (row, column, value) {
            return this.$cache.getDict("110003", value);
        },
        formatterTran (row, column, value) {
            return this.$cache.getDict("110001", value);
        },
        // 获取用户选中时间区间
        dateInterval (val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate) ? "" : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        pageRefresh (val) {
            this.pageoffset = val - 1;
            this.getInfo();
        },
        sizeReset (val) {
            this.curPage = 1;
            this.pageoffset = "0";
            this.pagecount = val + "";
            this.getInfo();
        },
        showAll (evt) {
            let target = evt.target;
            if (target) {
                if (target.nodeName === "SPAN") {
                    target = evt.target.parentNode;
                }
                target.blur();
            }
            this.isShowAll = !this.isShowAll;
            if (this.isShowAll) {
                this.pageLayout = "total, slot";
            } else {
                this.pageLayout = "total, slot, sizes, prev, pager, next";
            }
            this.curPage = 1;
            this.pageoffset = "0";
            this.getInfo();
        },
        getInfo() {
            this.endDate = this.endDate || this.nowDate;
            const noTime = new Date(this.$util.fmtDate(this.nowDate)).getTime();
            this.beginDate = this.beginDate || format(noTime - 7 * 24 * 3600 * 1000, "YYYYMMDD");
            const _x = {
                begindate: this.beginDate,
                enddate: this.endDate,
                fundcode: this.fundcode,
                pagecount: this.pagecount,
                pageoffset: (this.pageoffset * this.pagecount).toString(),
                ispage: this.isShowAll ? "0" : ""
            };
            this.$util.request("acct/dividend/info",_x, "GET", true).then(res => {
                if (res.data) {
                    this.data = res.data[0];
                    this.allPage = res.data[1][0].total;
                }
            });
        },
        // 搜索
        searchFund () {
            // if(this.$util.isEmpty(this.beginDate) || this.$util.isEmpty(this.endDate)){
            //     let _m = "请输入完整的日期范围";
            //     this.$alert(_m,"日期提示");
            //     this.fund = [];
            //     this.allPage = 0;
            //     return;
            // }
            this.getInfo(this.searchText);
        }
    }
};
</script>
<style lang="scss">
.view-dividend {
    /*自定义时间控件*/
    .custom-time {
        display: inline-block;
        vertical-align: middle;
        .comp-date-picker {
            width: auto;
        }
        .el-button {
            min-width: 100px;
            padding: 8px 15px;
            margin-left: 13px;
        }
    }
    .fund-filter{
        margin: 20px
    }
}
</style>
